import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  // Button,
  Hidden,
  Stack,
  Typography,
} from "@mui/material";
// import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {
  numberFormat,
  participationsFormat,
} from "../../../helpers/numberFormat";
import { PositionTableSmall } from "./PositionTableSmall";
import { DivestmentClubTableSmall } from "./DivestmentClubTableSmall";

// import {
//   exportToExcelWithTabs,
//   transformDivestmentData,
//   transformInvestmentData,
// } from "../../../helpers/exportToExcel";
// import { columnsByStartupDivestment } from "../../helpers/columns/columnDivestment";
// import { columnsByStartup } from "../../helpers/columns/columnsPosition";

export const TotalPositionSmall = ({ investmentList, divestmentList }) => {
  const { t } = useTranslation("global");
  const totalAmountInvestment = investmentList
    .map((invest) => invest.amount)
    .reduce((a, b) => a + b, 0);
  const capitalGainInvestment = investmentList
    .map((invest) =>
      invest.investmentType !== "Préstamo Convertible"
        ? (invest.amount / invest.participationValuation) * invest.newAmount -
          invest.amount
        : 0
    )
    .reduce((a, b) => a + b, 0);

  const totalAmountDivestment = divestmentList
    .map(
      (divest) => divest.divestmentParticipation * divest.participationValuation
    )
    .reduce((a, b) => a + b, 0);
  const capitalGainDivestment =
    divestmentList
      .map((divest) => divest.divestmentParticipation * divest.salesPrice)
      .reduce((a, b) => a + b, 0) - totalAmountDivestment;

  const totalInvest = totalAmountInvestment + totalAmountDivestment;
  const capitalGain = capitalGainInvestment + capitalGainDivestment;

  // Obtengo info para maquetar excel investment
  // const startupList = investmentList?.map((alias) => alias.alias);
  // const startupListNoRepeat = startupList?.filter((item, index) => {
  //   return startupList?.indexOf(item) === index;
  // });

  // const rows = startupListNoRepeat?.map((startup) => {
  //   return {
  //     id: startup,
  //     startup,
  //     data: investmentList?.filter(
  //       (investment) => investment?.alias === startup
  //     ),
  //   };
  // });
  // const columns = columnsByStartup(t);
  // const dataToInvesmentExcel = transformInvestmentData(rows, columns, t);

  // Obtengo info para maquetar excel Divestment
  // const startupListDivestment = divestmentList.map(
  //   (alias) => alias.startupAlias
  // );
  // const startupListNoRepeatDivestment = startupListDivestment.filter(
  //   (item, index) => {
  //     return startupListDivestment.indexOf(item) === index;
  //   }
  // );
  // const divestmentRows = startupListNoRepeatDivestment.map((startup) => {
  //   return {
  //     id: startup,
  //     startup,
  //     data: divestmentList.filter(
  //       (divestment) => divestment.startupAlias === startup
  //     ),
  //   };
  // });

  // const dataToDivestmentExcel = transformDivestmentData(
  //   divestmentRows,
  //   columnsByStartupDivestment(t),
  //   t
  // );

  return (
    <Hidden mdUp>
      <Stack width="100%" gap={3}>
        <Accordion width="100%">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Stack width="100%">
              <Typography
                gutterBottom
                textAlign="center"
                sx={{ fontWeight: "bold" }}
                variant="body1"
                color="primary"
              >
                {t("totalPosition.latent")}
              </Typography>
              <Stack direction="row" justifyContent="space-around">
                <Stack>
                  <Typography
                    textAlign="center"
                    variant="body2"
                    sx={{ fontWeight: "bold" }}
                    color="primary"
                  >
                    {t("totalPosition.investment")}
                  </Typography>
                  <Typography
                    textAlign="center"
                    variant="body2"
                    color="secondary"
                  >
                    {numberFormat(totalAmountInvestment.toFixed(2))}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography
                    textAlign="center"
                    variant="body2"
                    sx={{ fontWeight: "bold" }}
                    color="primary"
                  >
                    {t("totalPosition.capitalGains")}
                  </Typography>
                  <Typography
                    textAlign="center"
                    variant="body2"
                    color="secondary"
                  >
                    {numberFormat(capitalGainInvestment.toFixed(2))}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            {/* <Stack alignItems="flex-end">
              <Button
                onClick={() =>
                  exportToExcelWithTabs(
                    dataToInvesmentExcel,
                    "inversiones_latentes"
                  )
                }
                color="secondary"
                startIcon={<SaveAltIcon />}
              >
                {t("toExcel.export")}
              </Button>
            </Stack> */}
            <PositionTableSmall rows={investmentList} />
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Stack width="100%">
              <Typography
                gutterBottom
                textAlign="center"
                sx={{ fontWeight: "bold" }}
                variant="body1"
                color="primary"
              >
                {t("totalPosition.realized")}
              </Typography>
              <Stack direction="row" justifyContent="space-around">
                <Stack>
                  <Typography
                    textAlign="center"
                    variant="body2"
                    sx={{ fontWeight: "bold" }}
                    color="primary"
                  >
                    {t("totalPosition.investment")}
                  </Typography>
                  <Typography
                    textAlign="center"
                    variant="body2"
                    color="secondary"
                  >
                    {numberFormat(totalAmountDivestment.toFixed(2))}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography
                    textAlign="center"
                    variant="body2"
                    sx={{ fontWeight: "bold" }}
                    color="primary"
                  >
                    {t("totalPosition.capitalGains")}
                  </Typography>
                  <Typography
                    textAlign="center"
                    variant="body2"
                    color="secondary"
                  >
                    {numberFormat(capitalGainDivestment.toFixed(2))}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            {/* <Stack alignItems="flex-end">
              <Button
                onClick={() =>
                  exportToExcelWithTabs(
                    dataToDivestmentExcel,
                    "inversiones_realizadas"
                  )
                }
                color="secondary"
                startIcon={<SaveAltIcon />}
              >
                {t("toExcel.export")}
              </Button>
            </Stack> */}
            <DivestmentClubTableSmall rows={divestmentList} />
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <Stack width="100%" padding="10px 0">
            <Typography
              gutterBottom
              textAlign="center"
              sx={{ fontWeight: "bold" }}
              variant="body1"
              color="primary"
            >
              {t("totalPosition.global")}
            </Typography>
            <Stack direction="row" justifyContent="space-around">
              <Stack>
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ fontWeight: "bold" }}
                  color="primary"
                >
                  {t("totalPosition.investment")}
                </Typography>
                <Typography
                  textAlign="center"
                  variant="body2"
                  color="secondary"
                >
                  {numberFormat(totalInvest.toFixed(2))}
                </Typography>
              </Stack>
              <Stack>
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ fontWeight: "bold" }}
                  color="primary"
                >
                  {t("totalPosition.capitalGains")}
                </Typography>
                <Typography
                  textAlign="center"
                  variant="body2"
                  color="secondary"
                >
                  {numberFormat(capitalGain.toFixed(2))}
                </Typography>
              </Stack>
              <Stack>
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ fontWeight: "bold" }}
                  color="primary"
                >
                  TVPI
                </Typography>
                <Typography
                  textAlign="center"
                  variant="body2"
                  color="secondary"
                >
                  {participationsFormat(
                    (capitalGain + totalInvest) / totalInvest
                  )}
                  x
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Accordion>
      </Stack>
    </Hidden>
  );
};
